<template>
  <v-overlay :value="show" :opacity="0.2" color="rgba(255, 255, 255, 0.2)" z-index="9999">
    <div class="loading-container">
      <v-progress-circular :size="40" :width="4" color="indigo" indeterminate></v-progress-circular>
      <div class="mt-4 indigo--text">{{ message }}</div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      show: false,
      message: '加载中...'
    }
  },
  methods: {
    showLoading(message = '加载中...') {
      this.message = message
      this.show = true
    },
    hide() {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
// .loading-container {
//   text-align: center;
//   background-color: rgba(255, 255, 255, 0.5);
//   padding: 50px 80px;
//   border-radius: 10px;
// }
.mt-4 {
  margin-top: 16px;
}
.indigo--text {
  color: #3f51b5;
}
</style>
